import { connect } from "react-redux";
import MiscBar from "./MiscBar";
import { getFeature } from "@template/state/modules/features";

import { getDefaultStoreUrl } from "../../state/modules/regionalStore";

function mapStateToProps(state) {
  const marketplaceVintageLinkDesktop = getFeature(
    state,
    "emf-95-desktop-marketplace-clothing-nav-edit"
  );

  return {
    defaultStoreUrl: getDefaultStoreUrl(state),
    marketplaceVintageLinkDesktop: marketplaceVintageLinkDesktop
  };
}

export default connect(mapStateToProps)(MiscBar);
